var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.data.length > 0
    ? _c("div", { staticClass: "row reports-global-information" }, [
        _c("div", { staticClass: "col" }, [
          _c("div", { staticClass: "row" }, [
            _c("div", { staticClass: "col" }, [
              _c("div", { staticClass: "row" }, [
                _c(
                  "div",
                  { staticClass: "col-12 d-flex align-items-center mb-3" },
                  [
                    _vm.title
                      ? _c("span", { staticClass: "subtitle" }, [
                          _vm._v(_vm._s(_vm.$t(_vm.title))),
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.allowExportData
                      ? _c(
                          "button",
                          {
                            staticClass:
                              "btn btn-link min-w-auto text-decoration-none z-depth-0 py-0 m-0",
                            attrs: {
                              title: _vm.titleExportData,
                              type: "button",
                            },
                            on: {
                              click: function ($event) {
                                $event.preventDefault()
                                return _vm.onExport.apply(null, arguments)
                              },
                            },
                          },
                          [_c("i", { staticClass: "fas fa-download" })]
                        )
                      : _vm._e(),
                  ]
                ),
              ]),
            ]),
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "row info-row" },
            _vm._l(_vm.data, function (item, index) {
              return _c("div", { key: index, staticClass: "col info-col" }, [
                _c("div", { staticClass: "info-content" }, [
                  _c(
                    "p",
                    {
                      staticClass: "card-text text-nowrap info-title",
                      style: { color: item.color },
                    },
                    [
                      _vm._v(
                        "\n                        " +
                          _vm._s(item.name) +
                          "\n                    "
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "p",
                    { staticClass: "card-text info-qty" },
                    [
                      _c("number", {
                        attrs: {
                          from: 0,
                          to: item.period,
                          duration: 3,
                          delay: 0,
                          easing: "Power1.easeOut",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "p",
                    { staticClass: "card-text d-inline-block info-total" },
                    [
                      _c("span", { staticClass: "pr-2" }, [
                        _vm._v(_vm._s(_vm.txtTotal)),
                      ]),
                      _vm._v(" "),
                      _c("number", {
                        attrs: {
                          from: 0,
                          to: item.total,
                          duration: 3,
                          delay: 0,
                          easing: "Power1.easeOut",
                        },
                      }),
                    ],
                    1
                  ),
                ]),
              ])
            }),
            0
          ),
        ]),
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }